<template>
	<div
		class="pill"
		:class="{ '-light-mode': lightMode }"
		:style="wrapperStyle"
		@mouseenter.stop="handleEnter"
		@mouseleave.stop="handleLeave"
		@touchend.stop="handleEnter"
		@click="handleClick"
	>
		<div
			class="pill__fill"
		/>
	</div>
</template>

<script>
import { DOT_SIZE, DOT_SIZE_HOVERED, DOT_HOVERED_WIDTH_ADDITION } from './constants';

export default {
	name:  'TimelinePill',
	props: {
		group: {
			type:    Object,
			default: () => null,
		},
		hovered: {
			type: Boolean,
		},
		lightMode: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		tagIds() {
			return this.group.ids;
		},
		count() {
			return this.tagIds.length;
		},
		width() {
			if (!Number.isFinite(this.group.width)) return 'auto';
			return this.group.width;
		},
		wrapperStyle() {
			return {
				height: `${this.hovered ? DOT_SIZE_HOVERED : DOT_SIZE}px`,
				width:  `${this.hovered ? this.width + DOT_HOVERED_WIDTH_ADDITION : this.width}px`,
			};
		},
	},
	methods: {
		handleEnter(event) {
			this.$emit('enter', { event, group: this.group, ids: this.tagIds });
		},
		handleLeave(event) {
			this.$emit('leave', { event, group: this.group });
		},
		handleClick(event) {
			this.$emit('click', event);
		},
	},
};
</script>

<style lang="scss" scoped>
.pill {
	position: absolute;
	min-width: 20px;
}

.pill__fill {
	background-color: var(--color-white);
	border-radius: 80px;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: 100%;

	.pill.-light-mode & {
		background-color: var(--color-grey-500);
	}
}
</style>
